import { render } from "./ListeRole.vue?vue&type=template&id=79b2f9e2&ts=true"
import script from "./ListeRole.vue?vue&type=script&lang=ts"
export * from "./ListeRole.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__